var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('nav-bar'),_c('slider'),_c('health'),_c('entreprenuer'),_c('trending-debates'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }